module.exports = __webpack_public_path__ + "static/media/NaN.f98222c8.svg";